export const MAX_PAYMENT_PROOF_FILES = 5;
export const MAX_PAYMENT_PROOF_SIZE_MB = 5;

export const PAYMENT_PROOF_ACCEPTED_TYPES = {
  'application/pdf': ['.pdf'],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
};

export const PAYMENT_PROOF_INPUT_ACCEPT =
  'application/pdf,image/jpeg,image/png,.pdf,.jpg,.jpeg,.png';

type PaymentProofFileValidation =
  | { isValid: true }
  | { isValid: false; message: string };

export const validatePaymentProofFiles = (
  files: File[],
  maxFiles = MAX_PAYMENT_PROOF_FILES,
  maxSizeMb = MAX_PAYMENT_PROOF_SIZE_MB
): PaymentProofFileValidation => {
  if (files.length === 0) return { isValid: true };

  if (files.length > maxFiles) {
    return {
      isValid: false,
      message: `Maksimal ${maxFiles} file yang dapat diunggah`,
    };
  }

  if (files.some((file) => file.size > maxSizeMb * 1_000_000)) {
    return {
      isValid: false,
      message: `Ukuran file maksimal ${maxSizeMb} MB`,
    };
  }

  const acceptedMimeTypes = Object.keys(PAYMENT_PROOF_ACCEPTED_TYPES);
  if (files.some((file) => !acceptedMimeTypes.includes(file.type))) {
    return {
      isValid: false,
      message: 'Hanya menerima file PDF, PNG, JPG',
    };
  }

  return { isValid: true };
};
